export default {
  main: {
    entries: [
      {
        type: "link",
        href: "/",
        label: "Übersicht",
        icon: "fa-home"
      },
      {
        type: "menu",
        label: "Mandanten",
        icon: "fa-briefcase",
        conditional: appState => {
          return {
            show: Boolean(["super-admin"].includes(appState.user.navType))
          };
        },
        submenu: [
          {
            type: "link",
            href: "/client/create",
            label: "Anlegen",
            conditional: appState => {
              return {
                show: Boolean(["super-admin"].includes(appState.user.navType))
              };
            }
          },
          {
            type: "link",
            href: "/client/list",
            label: "Übersicht",
            conditional: appState => {
              let disabled = false;
              if (!Boolean(appState.user.clientCount)) disabled = true;
              return {
                show: Boolean(["super-admin"].includes(appState.user.navType)),
                disabled
              };
            }
          }
        ]
      },
      {
        type: "menu",
        label: "Institutionen",
        icon: "fa-university",
        conditional: appState => {
          return {
            show: Boolean(["verteilender-mandant", "lizensierender-mandant", "testender-mandant"].includes(appState.user.navType))
          };
        },
        submenu: [
          {
            type: "link",
            href: "/institution/create",
            label: "Anlegen",
            conditional: appState => {
              return {
                show: Boolean(["verteilender-mandant", "lizensierender-mandant", "testender-mandant"].includes(appState.user.navType))
              };
            }
          },
          {
            type: "link",
            href: "/institution/list",
            label: "Übersicht",
            conditional: appState => {
              let disabled = !Boolean(appState.user.client.institutions.length);
              return {
                show: Boolean(["verteilender-mandant", "lizensierender-mandant", "testender-mandant"].includes(appState.user.navType)),
                disabled: disabled
              };
            }
          }
        ]
      },
      {
        type: "menu",
        label: "Lizenzen",
        icon: "fa-file",
        conditional: appState => {
          return {
            show: Boolean(["super-admin", "verteilender-mandant", "lizensierender-mandant", "testender-mandant"].includes(appState.user.navType))
          };
        },
        submenu: [
          {
            type: "link",
            href: "/licences/assign",
            label: "Kontingente zuweisen",
            conditional: appState => {
              let disabled = false;
              if (appState.user.navType === "testender-mandant") {
                if (!Boolean(appState.user.client.licences.available) || !Boolean(appState.user.client.isActivated)) {
                  disabled = true;
                }
              }
              if (appState.user.navType === "verteilender-mandant" && !Boolean(appState.user.client.isActivated)) {
                disabled = true;
              }
              if (appState.user.navType === "super-admin" && !Boolean(appState.user.clientCount)) disabled = true;
              return {
                show: Boolean(["super-admin", "verteilender-mandant", "testender-mandant"].includes(appState.user.navType)),
                disabled
              };
            }
          },
          {
            type: "link",
            href: "/licences/generate",
            label: "Lizenzen versenden",
            conditional: appState => {
              let disabled = false;
              if (appState.user.client && appState.user.client.institutions && (!Boolean(appState.user.client.institutions.length) || !Boolean(appState.user.client.isActivated))) disabled = true;
              return {
                show: Boolean(["lizensierender-mandant"].includes(appState.user.navType)),
                disabled
              };
            }
          }
        ]
      },
      {
        type: "menu",
        label: "Testgruppen",
        icon: "fa-users",
        conditional: appState => {
          return {
            show: Boolean(["testender-mandant", "institution-admin", "autolizensierender-mandant"].includes(appState.user.navType))
          };
        },
        submenu: [
          {
            type: "link",
            href: "/testgroups/licences/generate",
            label: "Anlegen",
            conditional: appState => {
              let disabled = false;
              if (appState.user.navType === "institution-admin" && !Boolean(appState.user.institution.licences.available)) disabled = true;
              if (appState.user.navType === "testender-mandant") {
                if (!Boolean(appState.user.client.selfassignedInstitution.licences.available) || !Boolean(appState.user.client.isActivated)) {
                  disabled = true;
                }
              }
              return {
                show: Boolean(["testender-mandant", "institution-admin"].includes(appState.user.navType)),
                disabled
              };
            }
          },
          {
            type: "link",
            href: "/testgroups/licences/list",
            label: "Übersicht",
            conditional: appState => {
              return {
                show: Boolean(["testender-mandant", "institution-admin", "autolizensierender-mandant"].includes(appState.user.navType))
              };
            }
          }
        ]
      },
      {
        type: "menu",
        label: "Benutzer",
        icon: "fa-user",
        conditional: appState => {
          return {
            show: Boolean(["super-admin", "verteilender-mandant", "lizensierender-mandant", "testender-mandant", "autolizensierender-mandant"].includes(appState.user.navType) && appState.user.type.indexOf("admin") !== -1)
          };
        },
        submenu: [
          {
            type: "link",
            href: "/user/create",
            label: "Anlegen",
            conditional: appState => {
              return {
                show: Boolean(["super-admin", "verteilender-mandant", "lizensierender-mandant", "testender-mandant", "autolizensierender-mandant"].includes(appState.user.navType))
              };
            }
          },
          {
            type: "link",
            href: "/user/list",
            label: "Übersicht",
            conditional: appState => {
              return {
                show: Boolean(["super-admin", "verteilender-mandant", "lizensierender-mandant", "testender-mandant", "autolizensierender-mandant"].includes(appState.user.navType))
              };
            }
          }
        ]
      },
      {
        type: "link",
        href: "/texts",
        label: "Textverwaltung",
        icon: "fa-edit",
        conditional: appState => {
          return {
            show: Boolean(["verteilender-mandant", "lizensierender-mandant", "testender-mandant", "autolizensierender-mandant"].includes(appState.user.navType))
          };
        }
      },
      {
        type: "link",
        href: "/statistics",
        label: "Statistik",
        icon: "fa-chart-bar",
        conditional: appState => {
          return {
            show: Boolean(["super-admin", "verteilender-mandant", "lizensierender-mandant", "testender-mandant", "autolizensierender-mandant"].includes(appState.user.navType))
          };
        }
      },
      {
        type: "link",
        href: "/download",
        label: "Download",
        icon: "fa-download"
      },
      {
        type: "link",
        href: "/sendrequest",
        label: "Anfrage senden",
        icon: "fa-envelope",
        conditional: appState => {
          return {
            show: Boolean(["institution-admin"].includes(appState.user.navType))
          };
        }
      },
      {
        type: "button",
        action: "logout",
        label: "Logout",
        icon: "fa-sign-out-alt"
      }
    ]
  },
  footer: {
    /**
     * type: "link" | "external"
     * href, label, target
     */
    entries: [
      {
        type: "link",
        href: "/impressum",
        label: "Impressum"
      },
      {
        type: "link",
        href: "/datenschutz",
        label: "Datenschutz"
      },
      {
        type: "link",
        href: "/kontakt",
        label: "Kontakt"
      }
    ]
  }
};
